import { useEffect, useState } from "react"
import { MainBodyCard } from "components/Cards/MainBodyCard";
import { PagesTitle } from "components/Cards/PagesTitle";
import { useNavigate } from "react-router-dom";
import ChevronRightIcon from "assets/icon/ChevronRightIcon";

export default function Reports(){
    let navigate = useNavigate()

    return(
        <MainBodyCard className="flex flex-col gap-2">
            <PagesTitle title='Report' />

            <div className="w-full">
                <button className="py-2 px-2 flex justify-between w-full" onClick={() => navigate('/reports/detail-payment-report')}>
                    <span>Detail Payment Report</span>
                    <ChevronRightIcon className="w-5 fill-black" />
                </button>

                <hr />

                <button className="py-2 px-2 flex justify-between w-full" onClick={() => navigate('/reports/detail-booking-report')}>
                    <span>Detail Booking Report</span>
                    <ChevronRightIcon className="w-5 fill-black" />
                </button>

                <hr />
            </div>
        </MainBodyCard>
    )
}